import React from 'react';
import PropTypes from 'prop-types';
import { throttle } from 'lodash';
import { Search } from 'semantic-ui-react';
import NewSong from './NewSong';
import { RootConsumer } from '../../RootComponent';
import MobileSearch from './MobileSearch';

export default class SongSearch extends React.Component {
  static propTypes = {
    addToPlaylist: PropTypes.func.isRequired,
    searchResults: PropTypes.array.isRequired,
    refetchSearchResults: PropTypes.func.isRequired,
    listRef: PropTypes.object.isRequired,
    // we include playlist so the add icon updates when a new song is added
    playlist: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      newSong: {},
      newSongFormOpen: false,
      query: '',
      searchResults: []
    };
    this.search = throttle(this.search, 500, {
      trailing: true
    }).bind(this);
    this.onChange = this.onChange.bind(this);
    this.addToPlaylist = this.addToPlaylist.bind(this);
    this.openNewSongForm = this.openNewSongForm.bind(this);
    this.closeNewSongForm = this.closeNewSongForm.bind(this);
    this.newSongFieldChange = this.newSongFieldChange.bind(this);
    this.updateResults = this.updateResults.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.onResultSelect = this.onResultSelect.bind(this);
    this.playlistContainsSong = this.playlistContainsSong.bind(this);
  }

  onChange(e, { value }) {
    if (value === '') {
      this.clearSearch();
    } else {
      this.setState({ query: value }, this.search);
    }
  }

  onResultSelect(e, { result }) {
    const song = this.state.searchResults.find(s => s.id === result.id);
    this.addToPlaylist(e, song, this.props.playlist);
  }

  addToPlaylist(e, song, parent, onSuccess, onFailure) {
    this.props.addToPlaylist(
      e,
      song,
      parent,
      () => {
        this.clearSearch();
        // this.scrollToEnd();
        if (onSuccess) onSuccess();
      },
      onFailure
    );
  }

  openNewSongForm() {
    this.setState({
      newSongFormOpen: true,
      newSong: { name: this.state.query },
      query: ''
    });
  }

  closeNewSongForm() {
    this.clearSearch();
    this.setState({ newSongFormOpen: false, newSong: {} });
  }

  newSongFieldChange(e) {
    this.setState({
      newSong: Object.assign({}, this.state.newSong, {
        [e.target.name]: e.target.value
      })
    });
  }

  clearSearch() {
    const query = '';
    this.setState({ query, searchResults: [], loading: false });
  }

  scrollToEnd() {
    const { current } = this.props.listRef;
    current.scrollToItem(this.props.playlist.playlist_songs.edges.length - 1);
  }

  search() {
    this.setState({ loading: true });
    this.props.refetchSearchResults({ query: this.state.query }, null, () => {
      this.setState({ loading: false });
      this.updateResults(this.props.searchResults);
    });
  }

  updateResults(searchResults) {
    this.setState({ searchResults, loading: false });
  }

  playlistContainsSong(song) {
    for (const playlistSong of this.props.playlist.playlist_songs.edges) {
      if (playlistSong.node.song.isrc === song.isrc) return true;
    }
    return false;
  }

  render() {
    const {
      loading,
      newSong,
      newSongFormOpen,
      query,
      searchResults
    } = this.state;
    const { addToPlaylist, playlist } = this.props;
    const queryPresent = query !== '';
    const results = searchResults.map(result => ({
      id: result.id,
      key: result.id,
      title: result.name,
      description: result.artist
    }));

    const DesktopSearch = (
      <div style={{ position: 'relative' }} id='songSearch'>
        <Search
          icon={{
            name: queryPresent ? 'delete' : 'search',
            onClick: this.clearSearch,
            link: queryPresent
          }}
          className='songSearch'
          autoComplete='off'
          autoFocus
          placeholder='Add track by title, artist, or album...'
          loading={loading}
          fluid
          results={results}
          onSearchChange={this.onChange}
          onResultSelect={this.onResultSelect}
          value={query}
        />
        {newSongFormOpen &&
          <NewSong
            newSong={newSong}
            newSongFieldChange={this.newSongFieldChange}
            closeNewSongForm={this.closeNewSongForm}
            addToPlaylist={this.addToPlaylist}
          />}
      </div>);
    return (
      <RootConsumer>
        {({ isMobile }) =>
          <div>
            {isMobile
              ? <MobileSearch
                playlist={playlist}
                addToPlaylist={addToPlaylist}
                loading={loading}
                query={query}
                playlistContainsSong={this.playlistContainsSong}
                onChange={this.onChange}
                clearSearch={this.clearSearch}
                searchResults={searchResults}
              />
              : DesktopSearch}
          </div>}
      </RootConsumer>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Playlist/Song/Search.js